import { EuiSpacer } from '@elastic/eui';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import NumberField from '../../Form/NumberField';

const VariableDiscount = () => {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    return (
        <>
            <NumberField
                errors={errors}
                label='Threshold Amount'
                control={control}
                name='threshold_amount'
                placeholder='Enter Threshold Amount'
                rules={{
                    required: 'Please Enter Threshold Amount',
                }}
            />
            <EuiSpacer />
        </>
    );
};

export default React.memo(VariableDiscount);
